import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12 15a3 3 0 0 0 2.989-3.261A2 2 0 0 1 12.26 9.01 3 3 0 1 0 12 15"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.308 12.554c4.224 7.604 15.16 7.604 19.384 0a1.11 1.11 0 0 0-.014-1.1c-4.34-7.378-15.017-7.378-19.356 0a1.11 1.11 0 0 0-.014 1.1M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
      clipRule: "evenodd"
    }
  )
);
var SvgVisibleOnFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VisibleOnFilled_default = SvgVisibleOnFilled;

export { VisibleOnFilled_default as default };
